import type { ComicProject } from './comicTypes'

export function projectHasGeneratedImages(project: ComicProject): boolean {
  return project.episodes.some((ep) =>
    ep.panels.some((p) => p.candidates.length > 0 || Boolean(p.imageUrl)),
  )
}

export function getProjectPanelAspect(project: ComicProject): string {
  return project.creative.panelAspect?.trim() ?? ''
}
